import { Injectable } from '@angular/core';
import { IArc } from '../models/IArc';
import { IPolyline } from '../models/ILine';
import { IPoint } from '../models/IPoint';


@Injectable({ providedIn: 'root' })
export class GetPathGeneratorService {
  public getPathGenerator() {
    return new PathGenerator();
  }
}

export class PathGenerator {
  private _actualPath: string;

  constructor(prevPath?: string) {
    this._actualPath = prevPath ? prevPath : '';
  }

  get result() {
    return this._actualPath;
  }

  public addArc(model: IArc, isFirst: boolean, nextPoint: IPoint) {
    let outputStr = '';
    if (isFirst) {
      outputStr += `M ${model.start.x} ${model.start.y} `;
    }
    outputStr += `A ${model.radius} ${model.radius} 0 0 ${
      model.direction === 'Clockwise' ? 1 : 0
    } ${nextPoint.x} ${nextPoint.y} `;
    this._actualPath += outputStr;
  }

  public addLine(model: IPolyline, isFirst: boolean) {
    let outputStr = 'L ';
    model.points.forEach((p, i) => {
      if (i === 0 && isFirst) {
        outputStr = `M ${p.x} ${p.y} L `;
      } else {
        outputStr += `${p.x} ${p.y} `;
      }
    });
    this._actualPath += outputStr;
  }

  public close() {
    this._actualPath += 'Z';
  }
}
